<template>
  <div class="branch-tree">
    <article v-for="(b, i) in branches" :key="i" class="branch" :class="{ top: i === 0 }">
      <div class="branch-head">
        <span class="rank">{{ i + 1 }}</span>
        <b class="name">{{ b.name }}</b>
        <span class="prob-num">{{ pct(b.probability) }}%</span>
      </div>
      <div class="prob-bar"><div :style="{ width: pct(b.probability) + '%' }" /></div>
      <div class="branch-body">
        <p><span class="tag-support">支持</span>{{ b.support }}</p>
        <p><span class="tag-against">不支持</span>{{ b.against }}</p>
        <p><span class="tag-next">下一步</span>{{ b.next }}</p>
      </div>
    </article>
  </div>
</template>

<script>
// 诊断分支树：branches = [{name, probability, support, against, next}]，按概率降序
// 布局为两行式（病名行 + 整行概率条），宽窄容器都不挤爆
export default {
  name: 'BranchTree',
  props: {
    branches: { type: Array, default: () => [] },
  },
  methods: {
    // LLM 可能把 probability 返回成 "72%" / "72" / 72，统一成数字
    pct(v) {
      const n = typeof v === 'number' ? v : parseFloat(String(v ?? ''));
      return Number.isFinite(n) ? Math.max(0, Math.min(100, Math.round(n))) : 0;
    },
  },
};
</script>

<style scoped>
.branch { border: 1px solid var(--border-2); border-radius: var(--radius); padding: 14px 16px; margin-bottom: 10px; background: var(--bg-2); transition: transform 0.2s, border-color 0.2s; }
.branch:hover { transform: translateY(-2px); border-color: var(--border-hi); }
.branch.top { border-color: var(--border-hi); background: var(--grad-card); }
.branch-head { display: flex; align-items: center; gap: 10px; min-width: 0; }
.rank { display: inline-grid; place-items: center; width: 22px; height: 22px; background: var(--badge-num-bg); border-radius: 7px; font-size: 12px; flex: none; }
.name { font-size: 14px; line-height: 1.5; flex: 1; min-width: 0; overflow-wrap: anywhere; }
.prob-num { font-size: 12px; color: var(--accent); flex: none; }
.prob-bar { height: 8px; background: var(--sk-a); border-radius: 8px; overflow: hidden; margin-top: 8px; }
.prob-bar div { height: 100%; background: var(--grad-bar); border-radius: 8px; transition: width 0.6s ease; }
.branch-body { margin-top: 10px; }
.branch-body p { margin: 6px 0; font-size: 12px; color: var(--text-2); line-height: 1.7; }
.tag-support, .tag-against, .tag-next { display: inline-block; font-size: 11px; border-radius: 4px; padding: 1px 6px; margin-right: 8px; }
.tag-support { background: var(--success-a15); color: var(--success); }
.tag-against { background: var(--danger-a15); color: var(--danger); }
.tag-next { background: var(--primary-a15); color: var(--accent); }
</style>
